import React, { useContext } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box
} from '@mui/material';
import dayjs from 'dayjs';
import { OrderContext } from '../contexts/OrderContext';

const KarigarOrdersStats = () => {
  const { orders, storeData } = useContext(OrderContext);
  const karigars = storeData?.karigars || [];
  const allOrders = Object.values(orders || {}).flat();
  const today = dayjs();

  const getKarigarStats = () => {
    return karigars.map(karigar => {
      const userOrders = allOrders.filter(o => o.karigar_id === karigar.id);

      const calc = (filterFn) => {
        const filtered = userOrders.filter(filterFn);
        const netwt = filtered.reduce((sum, o) => sum + parseFloat(o.netwt || 0), 0);
        return { count: filtered.length, netwt };
      };

      return {
        name: karigar.name,
        completed: calc(o => o.work_status_id === 5),
        inProcess: calc(o => o.work_status === 'In Process' || o.work_status_id === 4),
        todayIssued: calc(o => o.work_status_id === 3 && dayjs(o.order_date).isSame(today, 'day')),
        overdue: calc(o => (o.work_status === 'In Process' || o.work_status_id === 4) && o.karigar_delivery_date && dayjs(o.karigar_delivery_date).isBefore(today, 'day')),
        stock: calc(o => o.order_type === 'Stock')
      };
    });
  };

  const stats = getKarigarStats();

  const renderStatCell = ({ count, netwt }) => (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        border: '1px solid #ccc',
        borderRadius: 1,
        overflow: 'hidden',
        width: '100%'
      }}
    >
      <Box sx={{ flex: 1, p: 1, textAlign: 'center', borderRight: '1px solid #ccc' }}>
        <Typography variant="body2">{count}</Typography>
      </Box>
      <Box sx={{ flex: 1, p: 1, textAlign: 'center' }}>
        <Typography variant="body2">{netwt.toFixed(3)}</Typography>
      </Box>
    </Box>
  );

  return (
    <Box sx={{ p: 4,mb:6 }}>
      <Card variant="outlined" sx={{ boxShadow: 3, borderRadius: 3 }}>
        <CardContent>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
            Karigar Order Stats Summary
          </Typography>
          <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
            <Table size="medium">
              <TableHead>
                <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                  <TableCell><strong>Karigar</strong></TableCell>
                  <TableCell align="center">
                    <Box>
                      <Typography variant="subtitle2" fontWeight="bold">Completed</Typography>
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    <Box>
                      <Typography variant="subtitle2" fontWeight="bold">In-Process</Typography>
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    <Box>
                      <Typography variant="subtitle2" fontWeight="bold">Today's Issued</Typography>
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    <Box>
                      <Typography variant="subtitle2" fontWeight="bold">Overdue</Typography>
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    <Box>
                      <Typography variant="subtitle2" fontWeight="bold">Stock</Typography>
                    </Box>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell align="center" colSpan={5}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-around' }}>
                      {[...Array(5)].map((_, i) => (
                        <Box key={i} sx={{ display: 'flex', width: '100%', justifyContent: 'center', borderLeft: i > 0 ? '1px solid #ccc' : 'none' }}>
                          <Box sx={{ flex: 1, textAlign: 'center' }}><Typography variant="body2" fontWeight={600}>Orders</Typography></Box>
                          <Box sx={{ flex: 1, textAlign: 'center' }}><Typography variant="body2" fontWeight={600}>Net Wt</Typography></Box>
                        </Box>
                      ))}
                    </Box>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {stats.map((karigar) => (
                  <TableRow key={karigar.name} hover>
                    <TableCell sx={{ fontWeight: 500 }}>{karigar.name}</TableCell>
                    <TableCell align="center">{renderStatCell(karigar.completed)}</TableCell>
                    <TableCell align="center">{renderStatCell(karigar.inProcess)}</TableCell>
                    <TableCell align="center">{renderStatCell(karigar.todayIssued)}</TableCell>
                    <TableCell align="center">{renderStatCell(karigar.overdue)}</TableCell>
                    <TableCell align="center">{renderStatCell(karigar.stock)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Box>
  );
};

export default KarigarOrdersStats;